import React, { useEffect, useState, useMemo, useLayoutEffect } from "react";
import { TableHeader, Pagination, Search } from "../../DataTable";
import UserListUseCaseHanlder from "../../../usecase/UserListUseCaseHandler";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Loader from "../../Utils/Loader";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Dialog, DialogContent, DialogTitle, Grid, Paper, Tooltip } from "@material-ui/core";
import Moment from "react-moment";
import TextField from '@material-ui/core/TextField';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import AttachMoneyRoundedIcon from '@material-ui/icons/AttachMoneyRounded';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined';
import StatusCardIpo from "../Dashboard/StatusCardIpo"
import IpoUser from "../Dashboard/IpoUser"
// import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const GuestUserList = (props) => {
  const [datas, setDatas] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const ITEMS_PER_PAGE = 10;

  const { allDatas, fetchedUserList, statusCode, message } = useSelector(
    (state: any) => ({
      allDatas: state.userListsReducer.allData,
      fetchedUserList: state.userListsReducer.fetchedUserList,
      message: state.userListsReducer.message,
      statusCode: state.userListsReducer.statusCode,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();




  useEffect(() => {
    dispatch(UserListUseCaseHanlder.getguestCallsDataIpo(fromDate, toDate));
  }, [fromDate, toDate]);

  useEffect(() => {
    setDatas(allDatas);
  }, [allDatas]);

  useEffect(() => {
    let username = localStorage.getItem("username");
  }, []);




  const handleDatetochange = (e) => {
    setToDate(e.target.value);
  };

  const handleDatefromchange = (e) => {
    setFromDate(e.target.value);
  };





  const [rowId, setRowId] = React.useState(null);
  const [isOpenTwo, setisOpenTwo] = React.useState(false);
  const handleDialogOpenTwo = (e, id) => {
    setisOpenTwo(true);
    setRowId(id);
  };
  const handleDialogCloseTwo = () => {
    setisOpenTwo(false);
  };






  const headers = [
    { name: "Client Inv19Id", field: "ClientInv19Id", sortable: false },
    { name: "Applicant Name", field: "ApplicantName", sortable: false },
    { name: "Demat Account", field: "DematAccount", sortable: false },
    { name: "Source", field: "Source", sortable: false },
    { name: "Ipo Apply Date", field: "IpoApplyDate", sortable: false },
    { name: "Ipo Name", field: "IpoName", sortable: false },
    { name: "Bid Amount", field: "BidAmount", sortable: false },
    { name: "Status", field: "Status", sortable: false },
    { name: "Referral", field: "referral", sortable: false },
  ];

  const datasData = useMemo(() => {
    let computedDatas = datas;
    if (computedDatas) {
      if (search) {
        computedDatas = computedDatas.filter(
          (data: any) =>
            data.symble.toLowerCase().includes(search.toLowerCase()) ||
            data.company_Name.toLowerCase().includes(search.toLowerCase())
        );
      }
      setTotalItems(computedDatas.length);
    }

    //Sorting datas
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedDatas = computedDatas.sort(
        (a: any, b: any) =>
          reversed *
          a[sorting.field]
            .toString()
            .localeCompare(b[sorting.field], undefined, {
              numeric: true,
            })
      );
    }

    //Current Page slice
    return computedDatas.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [datas, currentPage, search, sorting]);



  return (
    <>
<Grid container className="status">
<StatusCardIpo/>
</Grid>

      {/* <Search
        onSearch={(value) => {
          setSearch(value);
          setCurrentPage(1);
        }}
      /> */}
     <div className="date-filter searchUpdatesectin">
      <TextField
        id="fromdate"
        label="From date"
        type="date"
        value={fromDate}
        onChange={handleDatefromchange}
        InputLabelProps={{
          shrink: true,
        }}
      />
            <TextField
        id="todate"
        label="to date"
        type="date"
        value={toDate}
        onChange={handleDatetochange}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
      <Paper className="tableP">
 
        <Grid container className="listContainer">

          <Table stickyHeader className="tableD">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <TableBody>
              {fetchedUserList ? (
                datasData.map((data: any) => (
                  <TableRow className={data.actions} key={data.ClientInv19Id} id={data.ClientInv19Id}>
                    <TableCell align="left">
                      {data.ClientInv19Id}
                    {/* <Tooltip title="Click Here Details" aria-label="Details" placement="top">
                        <a href="#" className="D-btn" onClick={(e) => handleDialogOpenTwo(e, data.ClientBowId)}> </a>
                      </Tooltip> */}
                    </TableCell>
                    <TableCell align="left">{data.ApplicantName}</TableCell>
                    <TableCell align="left">{data.DematAccount}</TableCell>
                    <TableCell align="left">{data.Source}</TableCell>
                    <TableCell>
                    {data.IpoApplyDate}
                    {/* <Moment interval={30000} format="ll"> 
                          {data.IpoApplyDate}
                      </Moment> */}
                    </TableCell>
                    <TableCell align="left">{data.IpoName}</TableCell>
                    <TableCell align="left">{data.BidAmount}</TableCell>
                    <TableCell align="left">{data.Status}</TableCell>
                    <TableCell align="left"></TableCell>
                  </TableRow>
                ))
              ) : (
                <span className="loader-body">
                  <Loader />
                </span>
              )}
            </TableBody>
          </Table>
          <div>
            <Dialog open={isOpenTwo} onClose={handleDialogCloseTwo} className="user_Popup">
              {/* <DialogTitle>Confirm</DialogTitle> */}
              <DialogContent>
              <DialogTitle id="alert-dialog-title" className="faq-l">{"User Details"} </DialogTitle>
                {/* <DialogContentText>Add Faq</DialogContentText> */}
                <IpoUser rowId={rowId} />
              </DialogContent>

            </Dialog>
          </div>


        </Grid>
      </Paper>
      <div className="align-right">
        <Pagination
          total={totalItems}
          itemsPerPage={ITEMS_PER_PAGE}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};


export default GuestUserList;

